import type { UserSettings } from 'shared/types'

export const createBlankUserSettings = (): UserSettings => {
    const userSettings: UserSettings = {
        warningPriceDeviationPercent: 20,
    }

    return userSettings;
}